import React from 'react';
import { UserTacksShape, UserShape } from '../../shapes';
import UserTack from '../user_tack';
import Waiting from '../waiting';
import GettingStarted from '../getting_started';
import PropTypes from 'prop-types';

export default class TackBoardActiveTacks extends React.Component {
  static propTypes = {
    user: UserShape,
    userTacks: UserTacksShape,
    onFetchActiveTacks: PropTypes.func,
    onLikeTack: PropTypes.func,
    onUnLikeTack: PropTypes.func
  }

  componentDidMount() {
    this.props.onFetchActiveTacks();
  }

  render() {
    if (this.props.userTacks.get('error')) {
      return this.renderRetrievalError();
    } else if (this.props.userTacks.get('retrieving')) {
      return this.renderRetrieving();
    } else {
      return this.renderActiveTacks();
    }
  }

  renderActiveTacks() {
    if (this.props.userTacks.get('notDone').size > 0) {
      const activeTacks = this.props.userTacks.get('notDone').map((unFinishedTack, i) => {
        return (
          <li key={ i }><UserTack tack={ unFinishedTack } user={ this.props.user } onLikeTack={ this.props.onLikeTack } onUnLikeTack={ this.props.onUnLikeTack } /></li>
        );
      });

      return (
        <div className='user-tacks'>
          <div className='give-me-15-down'>
            <b>Active Tacks: { this.props.user.get('activeTacksCount') }</b>
          </div>
          <ol>{ activeTacks }</ol>
        </div>
      );
    } else {
      return (
        <div className='user-tacks'>
          <div className='give-me-15-down'>
            <b>Active Tacks: { this.props.user.get('activeTacksCount') }</b>
          </div>
          <GettingStarted />
        </div>
      )
    }
  }

  renderRetrieving() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    );
  }

  renderRetrievalError() {
    return(
      <div className='row tack-confirmation'>
        <div className='error col-sm-12' >
          { `Hmm. ${ this.props.userTacks.get('error') }.` }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_board/tack_board_active_tacks.jsx